// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rB9c","placeholdersHeader":"styles_placeholdersHeader__1cKZF","editorStyle":"styles_editorStyle__3qFYx","placeholdersBox":"styles_placeholdersBox__2Sq3Z"};